import { combineReducers } from 'redux';
import {
  GET_LOGIN_USER_INFO_SUCCESS
} from "../action-types/userInfo";

const userInfo = (state = {}, action) => {
  if (action.type === GET_LOGIN_USER_INFO_SUCCESS) {
    return { ...state, ...action.data,apiStatus:true }
  }
  return state
}

export default combineReducers({
  userInfo
})
